import { h } from '@debbie/cortex/dist/index.js';
import { useProcedures } from '@debbie/cortex/dist/procedures/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import SearchInput from './SearchInput.js';
const ProcedureSelector = (props) => {
    const lang = useSelector((s) => s.lang);
    const proceduresLoadable = useProcedures();
    const procedures = h.hasData(proceduresLoadable)
        ? proceduresLoadable.data
        : [];
    return (React.createElement(SearchInput, { loading: props.loading, forceOpen: true, placeholder: props.placeholder ?? lang.procedures.procedure, containerStyle: props.containerStyle, inputStyle: props.inputStyle, resultsStyle: props.resultsStyle, onSelect: (id) => props.onSelect(id), searchDelay: 50, searchAll: (q) => {
            return procedures
                .filter((procedure) => `${lang.procedureTitles[procedure.procedureId] || procedure.title} ${lang.procedureDescriptions[procedure.procedureId] ||
                procedure.description}`
                .toLowerCase()
                .indexOf(q.toLowerCase()) !== -1 || q.length === 0)
                .map((procedure) => ({
                key: procedure.procedureId,
                heading: lang.procedureTitles[procedure.procedureId] || procedure.title,
                subheading: lang.procedureDescriptions[procedure.procedureId] ||
                    procedure.description,
                returnData: procedure.procedureId,
            }));
        }, static: props.value
            ? (lang.procedureTitles[props.value] ??
                procedures.find((p) => p.procedureId === props.value)?.title ??
                '')
            : null, onRemoveStatic: () => props.onClear() }));
};
export default ProcedureSelector;
//# sourceMappingURL=ProcedureSelector.js.map